/* props for all modals in project. Could be overrided in components */
export default {
  clickToClose: false,
  width: 980,
  height: 'auto',
  scrollable: true,
  classes: ['rfx-modal']
}
